import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const initialState = {
    accepted: Cookies.get('shopify_agreement_accepted') === 'true'
};

export const agreementSlice = createSlice({
    name: 'agreement',
    initialState,
    reducers: {
        acceptAgreement: (state) => {
            state.accepted = true;
        },
        resetAgreement: (state) => {
            state.accepted = false;
            Cookies.remove('shopify_agreement_accepted');
        }
    }
});


export const { acceptAgreement, resetAgreement } = agreementSlice.actions;
export default agreementSlice.reducer;